/**
 * How long to wait before the next attempt, or null when there is no time left.
 * A loop that tests its deadline only BEFORE sleeping slept a grown backoff in
 * full, minutes past the expiry of the device code, or of a follow's budget.
 */
export function nextPollDelay(
  interval: number,
  remainingSeconds: number,
): number | null {
  if (remainingSeconds <= 0) {
    return null;
  }
  return Math.min(interval, remainingSeconds);
}
